/**
 * Force option order on custom apparel:
 * Size → Design → Brand → Color
 */
(function () {
  var ROW = 'uc-brand-color-row';
  var STACK = 'uc-option-stack';
  var timer = null;
  var busy = false;

  function norm(text) {
    return String(text || '')
      .replace(/\*/g, '')
      .replace(/required/gi, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function optionTitle(node) {
    if (!node) return '';
    var el =
      node.querySelector(
        ':scope > .tpo_label, :scope > [class*="tpo_label"], :scope > [class*="option-label"], :scope > legend, :scope > .form__label, :scope > h3, :scope > h4, :scope > .title'
      ) ||
      node.querySelector('.tpo_label, [class*="tpo_label"], [class*="option-label"], legend.form__label, .form__label');
    if (el && el.closest('.tpo_buttons-wrapper, [class*="tpo_swatch"], [class*="tpo_image"]')) {
      el = null;
    }
    if (!el) {
      // Walk direct children for a title-like node (not the button row)
      for (var i = 0; i < node.children.length; i++) {
        var child = node.children[i];
        if (
          child.matches(
            'label, legend, .tpo_label, [class*="tpo_label"], [class*="option-label"], h3, h4, .title, p, span, div'
          ) &&
          !child.matches('.tpo_buttons-wrapper, [class*="tpo_buttons"], select, input, textarea') &&
          !child.querySelector('select, input[type="radio"], input[type="checkbox"], textarea')
        ) {
          el = child;
          break;
        }
      }
    }
    if (!el) return '';
    var clone = el.cloneNode(true);
    clone.querySelectorAll('select, input, textarea, button, img, svg, small, .tpo_help, [class*="help"]').forEach(
      function (n) {
        n.remove();
      }
    );
    return norm(clone.textContent);
  }

  function isSize(t) {
    return t === 'size' || t === 'sizes' || t.indexOf('size') === 0;
  }
  function isBrand(t) {
    return t === 'brand' || t.indexOf('brand') === 0;
  }
  function isChart(t) {
    return t.indexOf('chart') !== -1;
  }
  function isColor(t) {
    // Never treat "Color Chart" as the Color box
    if (!t || isChart(t)) return false;
    return t === 'color' || t === 'colour' || t === 'color:' || t === 'colour:';
  }
  function isDesign(t) {
    return t === 'design' || t.indexOf('design') === 0;
  }

  function productInfo() {
    return (
      document.querySelector('product-info .product__info-container') ||
      document.querySelector('product-info .product__column-sticky') ||
      document.querySelector('product-info')
    );
  }

  function easifyRoot() {
    return (
      document.querySelector('.easify-product-options') ||
      document.querySelector('[class*="easify-product-options"]') ||
      document.querySelector('.shopify-block[class*="easify"]') ||
      null
    );
  }

  function variantRoot() {
    var stack = document.querySelector('.' + STACK);
    if (stack) {
      var inStack = stack.querySelector('variant-selects, variant-radios');
      if (inStack) return inStack;
    }
    return document.querySelector('product-info variant-selects, product-info variant-radios');
  }

  /** Dawn viewTransition briefly keeps two variant pickers — drop the hidden/extra copy. */
  function dedupeVariantSelects() {
    var info = productInfo();
    if (!info) return;

    var all = Array.prototype.slice.call(info.querySelectorAll('variant-selects, variant-radios'));
    if (all.length <= 1) return;

    var stack = info.querySelector('.' + STACK);
    var keeper = null;

    if (stack) {
      var inStack = all.filter(function (node) {
        return stack.contains(node);
      });
      keeper =
        inStack.find(function (node) {
          return node.style.display !== 'none';
        }) ||
        inStack[inStack.length - 1] ||
        null;
    }

    if (!keeper) {
      keeper =
        all.find(function (node) {
          return node.style.display !== 'none';
        }) || all[all.length - 1];
    }

    all.forEach(function (node) {
      if (node !== keeper) node.remove();
    });
  }

  function optionBlocks(root, allowInRow) {
    if (!root) return [];
    var blocks = [];
    var seen = {};
    var nodes = root.querySelectorAll(
      '.tpo_option-set, [class*="tpo_option-set"], [class*="option-set"], [class*="option-wrapper"], [class*="tpo_row"], .easify-product-options > div, [class*="easify"] > div, .' +
        ROW +
        ' > *'
    );
    nodes.forEach(function (node) {
      if (seen[node] || node.classList.contains(ROW) || node.classList.contains(STACK)) return;
      if (!allowInRow && node.closest('.' + ROW)) return;
      if (node.closest('.tpo_buttons-wrapper')) return;
      seen[node] = true;
      blocks.push(node);
    });
    return blocks;
  }

  function findEasify(pred) {
    var roots = [];
    var stack = document.querySelector('.' + STACK);
    var ez = easifyRoot();
    var info = productInfo();
    if (stack) roots.push(stack);
    if (ez) roots.push(ez);
    if (info) roots.push(info);

    var found = null;
    roots.forEach(function (root) {
      if (found) return;
      // Allow nodes already inside Brand|Color row (re-runs must still find Color)
      optionBlocks(root, true).forEach(function (node) {
        if (found) return;
        var title = optionTitle(node);
        if (!title || isChart(title)) return;
        if (pred(title)) found = node;
      });
    });
    if (found) return found;

    // Fallback scan
    for (var r = 0; r < roots.length; r++) {
      var all = roots[r].querySelectorAll('div, fieldset, section, label');
      for (var i = 0; i < all.length; i++) {
        var node = all[i];
        if (node.classList.contains(ROW) || node.classList.contains(STACK)) continue;
        var title = optionTitle(node);
        if (!title) continue;
        if (isChart(title)) continue;
        if (pred(title)) {
          return (
            node.closest(
              '.tpo_option-set, [class*="tpo_option-set"], [class*="option-set"], [class*="option-wrapper"], .' +
                ROW +
                ' > *'
            ) || node
          );
        }
      }
    }
    return null;
  }

  function findDesign() {
    var vs = variantRoot();
    if (!vs) return null;
    var fields = vs.querySelectorAll('.product-form__input');
    for (var i = 0; i < fields.length; i++) {
      if (isDesign(optionTitle(fields[i]))) return fields[i];
    }
    return null;
  }

  function ensureRow(brand, color) {
    if (!brand && !color) return null;
    if (brand && !color) return brand;
    if (color && !brand) return color;
    if (brand === color) return brand;

    var parent = brand.parentNode || color.parentNode;
    if (!parent) return brand || color;

    var row = (brand && brand.closest('.' + ROW)) || (color && color.closest('.' + ROW));
    if (!row) {
      row = document.createElement('div');
      row.className = ROW;
      parent.insertBefore(row, brand || color);
    }
    if (brand.parentNode !== row) row.appendChild(brand);
    if (color.parentNode !== row) row.appendChild(color);
    // Brand left, Color right
    if (row.firstElementChild !== brand) row.insertBefore(brand, color);
    else if (brand.nextElementSibling !== color) row.appendChild(color);

    // Keep "Please refer to the color chart..." help inside the Color column
    tetherColorHelp(color);
    return row;
  }

  function tetherColorHelp(color) {
    if (!color) return;
    // Help already inside Color block
    var inner = color.querySelectorAll('[class*="help"], .tpo_help, small, p, div, span');
    for (var i = 0; i < inner.length; i++) {
      var t = String(inner[i].textContent || '').toLowerCase();
      if (t.indexOf('color chart') !== -1 || t.indexOf('box above') !== -1) return;
    }
    // Orphaned help left outside Color (sibling / stack / easify root)
    var roots = [color.parentNode, easifyRoot(), productInfo(), document.querySelector('.' + STACK)].filter(Boolean);
    for (var r = 0; r < roots.length; r++) {
      var nodes = roots[r].querySelectorAll('[class*="help"], .tpo_help, small, p, div, span');
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (color.contains(node)) continue;
        if (node.closest('.' + ROW + ' > *') && node.closest('.' + ROW + ' > *') !== color) continue;
        var text = String(node.textContent || '').toLowerCase();
        if (text.indexOf('color chart') === -1 && text.indexOf('box above') === -1) continue;
        // Prefer the smallest matching node
        if (node.querySelector('select, input, textarea, .' + ROW)) continue;
        color.appendChild(node);
        return;
      }
    }
  }

  function ensureStack() {
    var info = productInfo();
    if (!info) return null;
    var stack = info.querySelector('.' + STACK);
    if (!stack) {
      stack = document.createElement('div');
      stack.className = STACK;
      var vs = variantRoot();
      var ez = easifyRoot();
      var anchor = vs || ez;
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(stack, anchor);
      else info.appendChild(stack);
    }
    return stack;
  }

  function append(stack, node) {
    if (!stack || !node) return;
    if (node.parentNode !== stack) stack.appendChild(node);
  }

  function alreadyGood(stack, size, vs, brandBlock) {
    if (!stack) return false;
    var kids = Array.prototype.filter.call(stack.children, function (n) {
      return n.nodeType === 1;
    });
    var i = 0;
    if (size) {
      if (kids[i] !== size) return false;
      i++;
    }
    if (vs) {
      if (kids[i] !== vs) return false;
      i++;
    }
    if (brandBlock) {
      // upload / design-request may sit between vs and brand
      while (i < kids.length && kids[i] !== brandBlock) {
        if (
          kids[i].hasAttribute('data-uc-design-request') ||
          kids[i].classList.contains('uc-design-request') ||
          kids[i].classList.contains('onhow-studio-upload-wrapper')
        ) {
          i++;
          continue;
        }
        return false;
      }
      if (kids[i] !== brandBlock) return false;
    }
    return true;
  }

  function reorder() {
    if (busy) return;
    dedupeVariantSelects();
    // Only custom / Design products — leave normal PDPs alone
    var design = findDesign();
    if (!design && !document.querySelector('.onhow-studio-upload-wrapper')) return;

    var size = findEasify(isSize);
    var brand = findEasify(isBrand);
    var color = findEasify(isColor);
    var vs = variantRoot();
    var brandBlock = ensureRow(brand, color);
    var stack = ensureStack();
    if (!stack || (!size && !vs && !brandBlock)) return;
    if (alreadyGood(stack, size, vs, brandBlock)) return;

    busy = true;
    try {
      if (size) append(stack, size);
      if (vs) append(stack, vs);

      // Keep Design request + upload under Design / after variant-selects
      var after = vs || design;
      document.querySelectorAll('[data-uc-design-request], .uc-design-request, .onhow-studio-upload-wrapper').forEach(
        function (el) {
          if (after && after.parentNode === stack) {
            if (el.parentNode !== stack || el.previousElementSibling !== after) {
              stack.insertBefore(el, after.nextSibling);
            }
            after = el;
          } else {
            append(stack, el);
            after = el;
          }
        }
      );

      if (brandBlock) append(stack, brandBlock);

      // Charts last
      optionBlocks(easifyRoot() || productInfo()).forEach(function (node) {
        if (isChart(optionTitle(node))) append(stack, node);
      });
    } finally {
      busy = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reorder, 120);
  }

  function scheduleFast() {
    clearTimeout(timer);
    timer = setTimeout(reorder, 0);
  }

  function onVariantPickerSwap() {
    dedupeVariantSelects();
    reorder();
    scheduleFast();
  }

  function boot() {
    dedupeVariantSelects();
    reorder();
    setTimeout(reorder, 300);
    setTimeout(reorder, 900);
    setTimeout(reorder, 1800);
    var host = productInfo() || document.body;
    if (host && window.MutationObserver) {
      new MutationObserver(function (mutations) {
        if (busy) return;
        var sawVariantSelects = mutations.some(function (mutation) {
          return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
            return (
              node.nodeType === 1 &&
              (node.matches('variant-selects, variant-radios') || node.querySelector('variant-selects, variant-radios'))
            );
          });
        });
        if (sawVariantSelects) onVariantPickerSwap();
        else schedule();
      }).observe(host, { childList: true, subtree: true });
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantPickerSwap);
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
      var target = event && event.data && event.data.target;
      if (!target || !target.closest('variant-selects, variant-radios, .product-form__input')) return;
      scheduleFast();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
